import { FC } from 'react';
import Alert from '../../../../ui/alert/alert';
import getContactEmail from '../../../../utils/contact-email';
import translation from '../../../../languages';
import FontAwesomeIcon from '../../../../ui/font-awesome-icon/font-awesome-icon';
import './error-message.scss';

export type ErrorMessageType = {
    reason?: string;
    message?: string;
}

type ErrorMessageProps = TranslationProps & {
    error: ErrorMessageType;
    onClose?: () => void;
};

const ErrorMessage: FC<ErrorMessageProps> = ({ error, onClose, t }) => {
    const ERRORS_MAPPING = {
        ATTEMPT_FAILED: 'Attempt failed',
        AUTHENTICATION_FAILURE:
            'Authentication failed due to missing authorization header, or invalid authentication credentials.',
        CANT_PROCEED: 'Can not proceed',
        INTERNAL_SERVER_ERROR: 'An internal server error occurred. A system or application error occurred.',
        INVALID_REQUEST: 'The request is not well-formed, is syntactically incorrect, or violates schema.',
        NOT_AUTHORIZED: 'Authorization failed due to insufficient permissions.',
        ORDER_CANCELLED: 'Order cancelled',
        ORDER_CONFIRMATION_FAILED: 'Order confirmation failed',
        RESOURCE_NOT_FOUND: 'The specified resource does not exist.',
        UNPROCESSABLE_ENTITY:
            'The requested action could not be completed, was semantically incorrect, or failed business validation.'
    };

    const errorMessage = error?.message ?? t('payment.failedTransaction', { email: getContactEmail() });

    return (
        <div className='payment-error-message position-relative'>
            <Alert variant='danger'>
                <h6 className=''>
                    <>
                        <FontAwesomeIcon className='icon' height={24} name='warning-triangle' theme='red' />
                        {errorMessage}
                    </>
                </h6>
                {error?.reason && ERRORS_MAPPING[error?.reason] && (
                    <div className='mt-1'>
                        {error.reason}: {t(`payment.paypalCheckoutErrors.${error.reason}`)}
                    </div>
                )}
                {Boolean(onClose) && (
                    <FontAwesomeIcon className='close-icon' height={12} name='close' theme='black' onClick={onClose} />
                )}
            </Alert>
        </div>
    );
};

const translate = translation('payment');

export default translate(ErrorMessage);
